"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _chunkOX4QNVYYjs = require('./chunk-OX4QNVYY.js');

var _jsxruntime = require('react/jsx-runtime');

var C = _chunkOX4QNVYYjs.c.call(void 0, {
  name: "ChevronDownIconSmall",
  size: "Small",
  svg: _jsxruntime.jsx.call(void 0, "path", {
    d: "M16.8886 7.73682L16.2626 7.11135C16.114 6.96288 15.8738 6.96288 15.7252 7.11135L10 12.8195L4.27481 7.11135C4.12623 6.96288 3.88597 6.96288 3.73738 7.11135L3.11144 7.73682C2.96285 7.88529 2.96285 8.12537 3.11144 8.27384L9.73129 14.8886C9.87987 15.0371 10.1201 15.0371 10.2687 14.8886L16.8886 8.27384C17.0371 8.12537 17.0371 7.88529 16.8886 7.73682Z"
  }),
  svgElements: ["path"]
}),
    a = exports.b = _chunkOX4QNVYYjs.c.call(void 0, {
  name: "ChevronDownIconMedium",
  size: "Medium",
  svg: _jsxruntime.jsx.call(void 0, "path", {
    d: "M23.8567 11.921L23.0519 11.1392C22.8609 10.9536 22.552 10.9536 22.361 11.1392L15 18.2744L7.63904 11.1392C7.44801 10.9536 7.1391 10.9536 6.94806 11.1392L6.14328 11.921C5.95224 12.1066 5.95224 12.4067 6.14328 12.5923L14.6545 20.8608C14.8455 21.0464 15.1545 21.0464 15.3455 20.8608L23.8567 12.5923C24.0478 12.4067 24.0478 12.1066 23.8567 11.921Z"
  }),
  svgElements: ["path"]
}),
    t = exports.c = _chunkOX4QNVYYjs.c.call(void 0, {
  name: "ChevronDownIconExtraSmall",
  size: "ExtraSmall",
  svg: _jsxruntime.jsx.call(void 0, "path", {
    d: "M11.9204 5.55262L11.4733 5.08351C11.3672 4.97216 11.1956 4.97216 11.0894 5.08351L7 9.36466L2.91058 5.08351C2.80445 4.97216 2.63283 4.97216 2.5267 5.08351L2.0796 5.55262C1.97347 5.66397 1.97347 5.84403 2.0796 5.95538L6.80806 10.9165C6.91419 11.0278 7.08581 11.0278 7.19194 10.9165L11.9204 5.95538C12.0265 5.84403 12.0265 5.66397 11.9204 5.55262Z"
  }),
  svgElements: ["path"]
});

exports.a = C;
exports.b = a;
exports.c = t;